import { operatorService } from '_services';
import { session } from '_helpers';
import { ACTIONS_OPERATOR } from '_constants/operator.constants';
import alertActions from './alert.actions';

export const receiveOperators = (operators) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < operators.length; i++) {
    byIdObjectToDispatch[operators[i].operatorID] = operators[i];
  }

  return {
    type: ACTIONS_OPERATOR.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteOperator = (operatorId) => ({
  type: ACTIONS_OPERATOR.DELETE,
  byId: { [operatorId]: null }
});

const getOperators = (accountID) => async (dispatch) => {
  try {
    const resp = await operatorService.getAll(accountID);
    if (resp?.[0]?.operatorID) {
      dispatch(receiveOperators(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving operators.', e));
  }
  return null;
};

const getOperator = (operatorID) => async (dispatch) => {
  try {
    const resp = await operatorService.getById(operatorID);
    if (resp?.operatorID) {
      dispatch(receiveOperators([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving operator #${operatorID}.`, e));
  }
  return null;
};

const addOperator = (operator) => async (dispatch) => {
  try {
    const resp = await operatorService.create(operator);
    if (resp?.operatorID) {
      dispatch(receiveOperators([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updOperator = (operator) => async (dispatch) => {
  try {
    const resp = await operatorService.update(operator);
    if (resp?.operatorID) {
      dispatch(receiveOperators([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delOperator = (operatorID) => async (dispatch) => {
  try {
    const resp = await operatorService.delete(operatorID);
    if (resp?.operatorID) {
      dispatch(deleteOperator(resp.operatorID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing operator #${operatorID}.`, e));
  }
  return null;
};

const operatorActions = {
  getOperators,
  getOperator,
  addOperator,
  updOperator,
  delOperator
};

export default operatorActions;
